import React, { useEffect, useState } from "react";

const useBernardAccess = () => {
  const [isAccess, setIsAccess] = useState(false);

    const accessList = [
    "Soumya.Mohanty@unilever.com",
    "komal.falodiya@unilever.com",
    "zufeshan.syeda@unilever.com",
    "gokul.sreenivas@unilever.com",
    "caique.amaral@unilever.com",
    "sneha.sagar2@unilever.com",
    "sweta.arya@unilever.com",
    "subhadip.das@unilever.com",
    "sajesh.m@unilever.com",
    "Rohit.Baid@unilever.com",
    "Aniket.Poddar@unilever.com",
    "Arresh.Velmurugan@unilever.com",
    "MS.Nayana@unilever.com",
    "Durgaprasadu.Povaru@unilever.com",
    "sudharson.m@unilever.com"
  ];

  let auth;

  if (typeof window !== "undefined") {
    auth = JSON.parse(localStorage.getItem("auth"))?.data;
  }

  useEffect(() => {
    for (let email of accessList) {
      if (auth?.email?.toLowerCase() === email.toLowerCase()) {
        setIsAccess(true);
      }
    }
  }, [accessList]);

  return { isAccess };
};

export default useBernardAccess;

